import "core-js/modules/es6.regexp.split.js";
import Nl2br from 'vue-nl2br';
var UnitParams = function UnitParams() {
  return import('@/components/molecules/UnitParams');
};
var StatusListItem = function StatusListItem() {
  return import('@/components/molecules/StatusListItem');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
export default {
  components: {
    UnitParams: UnitParams,
    Nl2br: Nl2br,
    StatusListItem: StatusListItem,
    RarityIcon: RarityIcon
  },
  props: {
    asset: {
      type: Object,
      required: true
    },
    isUnit: {
      type: Boolean,
      default: true
    },
    isTrade: {
      type: Boolean,
      default: false
    },
    isMint: {
      type: Boolean,
      default: false
    },
    isExAscensionConfirm: {
      type: Boolean,
      default: false
    },
    baseStatus: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      viewType: 0,
      internalBaseStatus: false
    };
  },
  computed: {
    getMax: function getMax() {
      return useExtensionStore().getMax;
    },
    raritiesMaxLv: function raritiesMaxLv() {
      return [{
        id: 0,
        lv: 40
      }, {
        id: 1,
        lv: 60
      }, {
        id: 2,
        lv: 70
      }, {
        id: 3,
        lv: 80
      }, {
        id: 4,
        lv: 90
      }, {
        id: 5,
        lv: 100
      }];
    },
    isLvMax: function isLvMax() {
      return this.asset.lv >= this.raritiesMaxLv[this.asset.rarity].lv;
    },
    summonComment: function summonComment() {
      var comment = this.$util.clone(this.asset.description[this.$i18n.locale]);
      comment = comment.split('<br>');
      return comment;
    }
  },
  watch: {
    baseStatus: {
      immediate: true,
      handler: function handler(value) {
        this.internalBaseStatus = value;
      }
    }
  },
  methods: {
    changeView: function changeView(idx) {
      this.viewType = idx;
    }
  }
};